import React from 'react';
import logger from '../../utils/logger';
 // Corrected import path

const RewardModal = ({ isOpen, onClose, stickerUrl, themeTitle }) => {
  console.log('RewardModal props:', { isOpen, stickerUrl, themeTitle });
  if (!isOpen || !stickerUrl) return null;

  // Check if device is mobile
  const isMobile = window.innerWidth < 1024;

  return (
    <div className="fixed inset-0 bg-black/70 z-50 p-4">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-6 text-center w-full max-w-sm animate-fade-in max-h-[90vh] overflow-y-auto">
        <span className="text-2xl font-bold text-yellow-500">Achievement Unlocked!</span>
        <p className="text-gray-600 mt-1 mb-4">You've mastered '{themeTitle}'!</p>
        <img
          src={stickerUrl}
          alt={themeTitle}
          className="w-48 h-48 mx-auto animate-bounce-slow"
        />
        <button
          onClick={onClose}
          className="mt-6 w-full bg-blue-500 text-white font-bold py-3 rounded-xl shadow-lg transition active:scale-95"
        >
          Awesome!
        </button>
      </div>
    </div>
  );
};

export default RewardModal;
